module.exports = __webpack_public_path__ + "img/macao.444e223e.svg";